import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  awardsReminders: null,
  awardsRemindersTotalItems: 0,
  awardsRemindersTotalPages: 0
}

const getters = {
  getAwardsReminders: state => state.awardsReminders,
  getAwardsRemindersTotalItems: state => state.awardsRemindersTotalItems,
  getAwardsRemindersTotalPages: state => state.awardsRemindersTotalPages
}

const actions = {
  async fetchAwardsReminders ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsReminders.fetchReminders(), { params: { itemsOnPage: 9999 } })
      commit(types.SET_AWARDS_REMINDERS, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards reminders wasn\'t loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async postAwardReminders ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.awardsReminders.sendReminder())
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards reminder wasn\'t sent')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_AWARDS_REMINDERS] (state, { reminders }) {
    state.awardsReminders = reminders
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/awards-reminders.js